import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ShopIcon, ChevronDownIcon } from '../../../model/icons';
import PointCard from './PointCard';

// Карточка площадки (.fr-venue): владелец, точки (сворачиваемые), добавление точки.
export default function VenueCard({ area, colorOf, qrBaseUrl, onEdit, onDelete, onAddPoint, onPointClick, onShowPointTx }) {
    const [open, setOpen] = useState(false);
    const points = [...(area.points || [])].sort((a, b) => a.id - b.id);
    const ownerColor = colorOf(area.teamStateId);

    return (
        <div className="fr-venue" style={{ borderLeftColor: ownerColor || 'var(--line)' }}>
            <div className="fr-vhead">
                <div className="fr-vname">
                    <span className="shop"><ShopIcon /></span>
                    {area.name}
                    {area.teamName
                        ? <span className="fr-vown acc"><span className="bdot" style={{ background: ownerColor }} />{area.teamName}</span>
                        : <span className="fr-vown">— не назначена —</span>}
                </div>
                <div className="fr-vacts">
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => onEdit(area)}>Редактировать</button>
                    <button type="button" className="btn btn-danger btn-sm" onClick={() => onDelete(area)}>Удалить</button>
                </div>
            </div>

            <div className={`fr-phead${open ? ' col' : ''}`} role="button" tabIndex={0} onClick={() => setOpen(!open)} onKeyDown={(e) => { if (e.key === 'Enter') setOpen(!open); }}>
                <h3>Точки <span className="cnt">({points.length})</span></h3>
                <div className="fr-pheadr">
                    <button type="button" className="btn btn-primary btn-sm" onClick={(e) => { e.stopPropagation(); onAddPoint(area); }}>Добавить точку</button>
                    <span className="fr-chev"><ChevronDownIcon /></span>
                </div>
            </div>

            {open && (
                points.length > 0 ? (
                    <div className="fr-points">
                        {points.map((point, index) => (
                            <PointCard key={point.id} point={point} index={index} qrBaseUrl={qrBaseUrl} onOpen={onPointClick} onShowTx={onShowPointTx} />
                        ))}
                    </div>
                ) : <div className="bt-empty">Нет точек на этой площадке</div>
            )}
        </div>
    );
}

VenueCard.propTypes = {
    area: PropTypes.object.isRequired,
    colorOf: PropTypes.func.isRequired,
    qrBaseUrl: PropTypes.string,
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onAddPoint: PropTypes.func.isRequired,
    onPointClick: PropTypes.func.isRequired,
    onShowPointTx: PropTypes.func
};

VenueCard.defaultProps = { qrBaseUrl: null, onShowPointTx: null };
